import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import AdminTransferReportsDataGrid from "../../components/AdminTransferReportsDataGrid";

const AdminReportsPage = () => {
  const currentUser = useSelector((state) => state.currentUser);

  useEffect(() => {
    document.title = "TransferMyRx::Reports";
    const pageTitle = document.getElementById("page-title-text");
    if (pageTitle) {
      pageTitle.innerText = "Reports";
    }
  }, []);

  if (currentUser?.user?.roleId !== 1) {
    return <>No Access</>;
  }

  return <AdminTransferReportsDataGrid />;
};

export default AdminReportsPage;
